export default __webpack_public_path__ + "static/media/pnu2.bcd68d43.jpg";